module.exports = __webpack_public_path__ + "img/EditorialBallastVergangenheitThumbnail-400.04e821b0.jpg";